/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 * @description tourTypeLabels
 */

import { IntegratedTourType } from '@zcode/enums'

const tourTypeLabels = {
  [IntegratedTourType.AGENT_GUIDED]: 'In-person',
  [IntegratedTourType.LIVE_VIRTUAL]: 'Live virtual',
  [IntegratedTourType.SELF_GUIDED]: 'Self-guided',
} as const

export const getTourTypeLabel = (option: IntegratedTourType, addTour?: boolean) =>
  `${tourTypeLabels[option]}${addTour ? ' tour' : ''}`
